<template>
  <v-dialog persistent :value="showModal" @input="closeModal" max-width="600">
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>

        <v-card-media :src="item.imagesUrls.originalImageUrl" height="250px">
          <v-container fill-height fluid>
            <v-layout fill-height justify-end>
              <v-btn fab

                     color="grey darken-1"
                     @click="closeModal"
              ><v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-media>

        <v-card-title primary-title>
          <v-container fluid grid-list-md>
          <v-layout row>
            <v-flex>
              <content-field
                label="Title"
                suffix="Title"
                color="grey darken-3"
                v-model="currentItem.title"
                @input="$v.currentItem.title.$touch()"
                @blur="$v.currentItem.title.$touch()"
                :error="$v.currentItem.title"
              ></content-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex>
              <content-field
                label="Alt"
                suffix="Alt"
                color="grey darken-3"
                v-model="currentItem.alt"
              ></content-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex>
              <v-select
                label="Categories"
                chips
                tags
                append-icon=""
                v-model="currentItem.categories"
              >
                <template slot="selection" slot-scope="category">

                  <v-chip
                    close
                    class="pointer"
                    @click="filterGalleriesByCategory(category.item)"
                    @input="removeItemCategory(category.item)"
                    :selected="category.selected"
                  >
                    <span class="pointer">{{category.item}}</span>
                  </v-chip>

                </template>
              </v-select>
            </v-flex>
          </v-layout>
          </v-container>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            color="blue-grey darken-3"
            @click="closeModal"
          >Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            flat
            color="blue-grey darken-3"
            @click="updateImage(currentItem)"
            :disabled="!isWriteAvailable"
          >Save
          </v-btn>
          <v-spacer />
        </v-card-actions>

      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { filter } from 'ramda'
import { validationMixin } from 'vuelidate'
import { alpha } from 'vuelidate/lib/validators'
import mixins from '@/utils/mixins'
import ContentField from '@/components/shared/ContentField'

  export default {
    name: "imageModal",
    mixins: [validationMixin, mixins.isWriteAvailable],
    components: {ContentField},
    validations: {
      currentItem: {
        title: { alpha }
      }
    },
    data () {
      return {
        showModal: this.show,
        item: this.currentItem,
        valid: true,
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'general_settings:write'
      }
    },
    props: {
      show: false,
      currentItem: {
        id: '',
        alt: '',
        title: '',
        categories: [],
        imagesUrls: {}
      }
    },
    methods: {
      ...mapActions([
        'updateImageDetails',
        'showResultErrorMessage'
      ]),
      closeModal () {
        this.$emit('closeModal')
      },
      async updateImage(currentItem) {
        this.$v.$touch()
        if(this.$v.$invalid) return
        const {id, alt, title, categories} = currentItem
        await this.updateImageDetails({id, alt, title, categories})
        this.$bus.$emit('getGalleries')
        this.closeModal()
      },
      removeItemCategory(category){
        this.currentItem.categories = filter(item=>item !== category, this.currentItem.categories)
      },
      filterGalleriesByCategory(category){
        this.$bus.$emit('getGalleries', {category})
      },
    },
    watch: {
      show() {return this.showModal =  this.show},
      currentItem() {return this.item =  this.currentItem}
    }
  }
</script>

<style>
  .pointer {
    cursor: pointer !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Gallery/imageModal.vue